import React, { useEffect, useState } from "react";
import "../assets/AdviceCare.css";
import { getAdvice, getAdviceCareBlog } from "../services/api/adviceCareApi";
import { useNavigate } from "react-router-dom";


export default function AdviceCare() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]); // store API data
  const [hero, setHero] = useState(null);

useEffect(() => {
  const fetchData = async () => {
    try {
      // 🔹 HERO DATA
      const heroData = await getAdvice();
      setHero(heroData);

      // 🔹 CARDS DATA
      const blogData = await getAdviceCareBlog();
      setCards(blogData);

      console.log("BLOG DATA:", blogData);

    } catch (error) {
      console.error("Error fetching AdviceCare data:", error);
    }
  };

  fetchData();
}, []);
  const handleClick = (id) => {
    navigate(`/adviceCareDetails/${id}`);
  };


  return (
    <>
      {/* hERO SECTION */}
     {hero && (
  <div className="news-hero">
    <div className="hero-left">
      <div className="breadcrumb">
        Home &nbsp; › &nbsp; <span>Advice & Care</span>
      </div>

      <h1>{hero.title}</h1>
      <h5>{hero.short_description}</h5>
      <p>{hero.full_description}</p>
    </div>

    <div className="hero-right">
      <img src={hero.image} alt="hero" />
    </div>
  </div>
)}

      {/* CARDS SECTION */}
      <div className="advice-section">
        <div className="card-grid">
          {cards.map((card) => (
            <div key={card.id} className="card-wrapper">
              <div
                className="custom-card "
                onClick={() => handleClick(card.id)}
              >
                <span className="card-tag">{card.tag}</span>
                <h3>{card.title}</h3>
                <p>{card.short_description}</p>

                <div className="card-image">
                  <img src={card.image} alt="card" />
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>
    </>
  );
}